import { CategoryQuestions } from '../types';

export const anxietyQuestions: CategoryQuestions = {
  title: 'Personalize Your Anxiety Relief',
  questions: {
    preferredStyle: {
      label: 'What helps you most when anxious?',
      type: 'radio',
      options: ['Breathing exercises', 'Progressive muscle relaxation', 'Positive affirmations', 'Grounding techniques']
    },
    primaryGoal: {
      label: 'What type of anxiety relief do you need?',
      type: 'radio',
      options: ['Immediate panic relief', 'General stress reduction', 'Sleep anxiety help', 'Social anxiety support']
    },
    specificFocus: {
      label: "What's triggering your anxiety right now?",
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  // Practitioner perspective questions
  practitionerTitle: 'Personalize Anxiety Relief for Your Client',
  practitionerQuestions: {
    preferredStyle: {
      label: 'What helps your client most when anxious?',
      type: 'radio',
      options: ['Breathing exercises', 'Progressive muscle relaxation', 'Positive affirmations', 'Grounding techniques']
    },
    primaryGoal: {
      label: 'What type of anxiety relief does your client need?',
      type: 'radio',
      options: ['Immediate panic relief', 'General stress reduction', 'Sleep anxiety help', 'Social anxiety support']
    },
    specificFocus: {
      label: "What's triggering your client's anxiety right now?",
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  practitionerGroupTitle: 'Personalize Group Anxiety Relief for Your Clients',
  practitionerGroupQuestions: {
    groupAnxietyContext: {
      label: 'What type of group anxiety support are you creating for your clients?',
      type: 'radio',
      options: ['Family dealing with shared stress', 'Support group session', 'Team/workplace stress relief', 'Friends supporting each other', 'Therapy group activity', 'Crisis support group']
    },
    sharedTriggers: {
      label: 'What is causing anxiety for the group?',
      type: 'textarea',
      placeholder: 'Describe the shared stressors, events, or situations affecting the group...'
    },
    groupSupport: {
      label: 'How does the group work best together during stress?',
      type: 'radio',
      options: ['Shared breathing and calming exercises', 'Taking turns sharing and supporting', 'Silent group presence and solidarity', 'Guided group affirmations and encouragement']
    },
    anxietyLevels: {
      label: 'What are the anxiety levels in the group?',
      type: 'radio',
      options: ['Everyone highly anxious - need immediate relief', 'Mixed anxiety levels', 'Mild group stress', 'One person very anxious, others supportive']
    },
    copingApproach: {
      label: 'What coping approach works best for the group?',
      type: 'radio',
      options: ['Collective grounding techniques', 'Individual practice with group support', 'Partner/buddy system exercises', 'Group affirmations and reassurance']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your clients?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Anxiety Relief',
  groupQuestions: {
    groupAnxietyContext: {
      label: 'What type of group anxiety support are you creating?',
      type: 'radio',
      options: ['Family dealing with shared stress', 'Support group session', 'Team/workplace stress relief', 'Friends supporting each other', 'Therapy group activity', 'Crisis support group']
    },
    sharedTriggers: {
      label: 'What is causing anxiety for your group?',
      type: 'textarea',
      placeholder: 'Describe the shared stressors, events, or situations affecting the group...'
    },
    groupSupport: {
      label: 'How does your group work best together during stress?',
      type: 'radio',
      options: ['Shared breathing and calming exercises', 'Taking turns sharing and supporting', 'Silent group presence and solidarity', 'Guided group affirmations and encouragement']
    },
    anxietyLevels: {
      label: 'What are the anxiety levels in your group?',
      type: 'radio',
      options: ['Everyone highly anxious - need immediate relief', 'Mixed anxiety levels', 'Mild group stress', 'One person very anxious, others supportive']
    },
    copingApproach: {
      label: 'What coping approach works best for your group?',
      type: 'radio',
      options: ['Collective grounding techniques', 'Individual practice with group support', 'Partner/buddy system exercises', 'Group affirmations and reassurance']
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  giftTitle: 'Personalize Anxiety Relief for Your Loved One',
  giftQuestions: {
    preferredStyle: {
      label: 'What helps your loved one most when anxious?',
      type: 'radio',
      options: ['Breathing exercises', 'Progressive muscle relaxation', 'Positive affirmations', 'Grounding techniques']
    },
    primaryGoal: {
      label: 'What type of anxiety relief do they need?',
      type: 'radio',
      options: ['Immediate panic relief', 'General stress reduction', 'Sleep anxiety help', 'Social anxiety support']
    },
    specificFocus: {
      label: "What's triggering their anxiety right now?",
      type: 'textarea',
      placeholder: 'Optional - leave blank for general session'
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  }
};
